import { cx } from '@linaria/core';
import { avoidBreakInside } from '@provider/print';
import { CrossIcon, RoundedCheckmarkIcon } from '@ui/kit/icons';
import { usePageContext } from '../../../../context.js';
import { icon, wrapper } from './_state-box.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function StateBox(props) {
  const pageContext = usePageContext();
  const icon$1 = (() => {
    switch (props.state) {
      case "correct":
        return /*#__PURE__*/jsx(RoundedCheckmarkIcon, {});
      case "incorrect":
        return /*#__PURE__*/jsx(CrossIcon, {
          strokeWidth: 1.5,
          height: 10
        });
    }
  })();
  return /*#__PURE__*/jsxs("div", {
    className: cx(props.className, wrapper),
    "data-shadow": props.withShadow,
    "data-state": props.state,
    "data-page-context": pageContext,
    "data-text-theme": props.textTheme ?? "black",
    ...avoidBreakInside(icon$1 ? {
      extend: {
        top: 9
      }
    } : undefined),
    children: [/*#__PURE__*/jsx("span", {
      children: props.children
    }), icon$1 && /*#__PURE__*/jsx("span", {
      className: icon,
      children: icon$1
    })]
  });
}

export { StateBox };
//# sourceMappingURL=_state-box.js.map
